<template>
  <div>
    <modal-cadu close :width="940" v-model="valueData">
      <div slot="all" class="py-10 px-10">
        <div slot="header" class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
          {{ nomeAcao }} DIRIGENTE
        </div>

        <div slot="body">
          <component-loading :value="isLoading" />

          <ValidationObserver ref="observer">
            <div v-if="!isLoading">
              <v-row>
                <v-col cols="12" sm="4" class="pb-0">
                  <input-cadu
                    v-model="tipoMandato"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                    title="Tipo de Mandato"
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3" class="pb-0">
                  <datepicker-cadu
                    width="280"
                    inputTitle="Data Início"
                    typeCalendar="date"
                    :inputValue="dataInicio"
                    disabled
                  ></datepicker-cadu>
                </v-col>

                <v-col cols="12" sm="3" md="3" class="pb-0">
                  <datepicker-cadu
                    width="280"
                    inputTitle="Data Fim"
                    typeCalendar="date"
                    :minDate="dataInicio"
                    :inputValue="dataFim"
                    disabled
                  ></datepicker-cadu>
                </v-col>

                <v-col cols="12" sm="auto" class="pt-9">
                  <checkbox-cadu v-model="vigencia" disable>
                    <div slot="text">Vigente</div>
                  </checkbox-cadu>
                </v-col>
              </v-row>

              <v-row v-if="nomeAcao === 'ADICIONAR'">
                <v-col cols="12" md="6">
                  <search-bar
                    nameInput="searchText"
                    nameButton="searchBtn"
                    ref="barraPesquisa"
                    v-model="barraPesquisa"
                    placeholder="pesquisar por nome, crm ou cpf"
                    @pesquisar="pesquisar"
                    @selecionado="preencherCampos"
                    :items="pesquisaNova"
                    quadrado
                  />
                </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="12" md="2">
                  <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
                    <input-cadu :errorMessage="errors[0]" title="Tratamento" disabled v-model="tratamento" />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="4">
                  <ValidationProvider mode="eager" rules="required|max:60" v-slot:default="{ errors }">
                    <input-cadu :errorMessage="errors[0]" title="Nome" disabled v-model="nome" :max="60" />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="3" v-if="!isColaboradorDirigente">
                  <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
                    <input-cadu :errorMessage="errors[0]" title="CPF" mask="###.###.###-##" disabled v-model="cpf" />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="3" v-if="!isColaboradorDirigente">
                  <ValidationProvider mode="eager" rules="dateValidator" v-slot:default="{ errors }">
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Data Nascimento"
                      mask="##/##/####"
                      disabled
                      v-model="dataNascimento"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <ValidationProvider mode="eager" rules="required" v-slot:default="{ errors }">
                    <autocomplete-cadu
                      class="cargo-dirigente"
                      :errorMessage="errors[0]"
                      v-model="tipoCargo.nome"
                      :items="listaCargos.map((el) => el.nome)"
                      :colorText="$vuetify.theme.themes.light.fontColor1"
                      title="Cargo"
                      :disabled="nomeAcao === 'VISUALIZAR'"
                      @index="setIdCargo"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <!-- <ValidationProvider
                    ref="email"
                    mode="eager"
                    rules="required|email|max:100"
                    v-slot:default="{ errors }"
                  >
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="E-mail"
                      :disabled="nomeAcao === 'VISUALIZAR'"
                      :onlyUpperCase="false"
                      v-model="email"
                      :max="100"
                    />
                  </ValidationProvider> -->

                  <div v-for="(email, index) in emails" :key="index">
                    <v-row>
                      <v-col cols="8" md="8">
                        <ValidationProvider ref="email.emailAdress" mode="eager" rules="required|email|max:100" v-slot:default="{ errors }">
                          <input-cadu
                            :errorMessage="errors[0]"
                            :disabled="nomeAcao === 'VISUALIZAR'"
                            title="E-mail"
                            v-model="email.emailAdress"
                            :max="50"
                            emailMask
                            :colorText="$vuetify.theme.themes.light.fontColor1"
                            :onlylowerCase="true"
                          />
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="3" md="3" class="pd-top-icon">
                        <br />
                        <button-rounded
                          v-if="nomeAcao === 'EDITAR'"
                          iconName="plus"
                          :iconSize="16"
                          @click="addMore()"
                          :backColor="$vuetify.theme.themes.light.primary2"
                          title="Adicionar"
                        />

                        <button-rounded
                          iconName="x"
                          :iconSize="16"
                          v-if="emails.length > 1 && index != 0 && nomeAcao === 'EDITAR'"
                          @click="remove(index)"
                          v-show="index != 0"
                          :backColor="$vuetify.theme.themes.light.primary2"
                          title="Excluir"
                        />
                      </v-col>
                    </v-row>
                  </div>







                </v-col>
              </v-row>

              <v-row>
                <v-col> <div slot="header" class="primary1--text title font-weight-bold">TELEFONES</div> </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3">
                  <ValidationProvider
                    ref="telefone"
                    mode="eager"
                    rules="required|telRequired"
                    v-slot:default="{ errors }"
                  >
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Comercial"
                      :disabled="nomeAcao === 'VISUALIZAR'"
                      v-model="telefoneComercial"
                      mask="(##) ####-####"
                    />
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="3">
                  <ValidationProvider
                    ref="celular"
                    mode="eager"
                    rules="required|telRequired"
                    v-slot:default="{ errors }"
                  >
                    <input-cadu
                      :errorMessage="errors[0]"
                      title="Celular"
                      :disabled="nomeAcao === 'VISUALIZAR'"
                      mask="(##) #####-####"
                      v-model="telefoneCelular"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
            </div>
          </ValidationObserver>
        </div>

        <div slot="footer" class="pt-4">
          <v-row align="center" justify="end" no-gutters v-if="nomeAcao === 'VISUALIZAR'">
            <v-col cols="auto"> <button-cadu @click="fecharModal" text="VOLTAR" /> </v-col>
          </v-row>

          <v-row justify="start" v-else-if="nomeAcao === 'EDITAR'">
            <v-col cols="auto">
              <button-cadu @click="cancelarEdicao" outline> CANCELAR </button-cadu>
            </v-col>

            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu :backColor="$vuetify.theme.themes.light.primary2" @click="limparCamposDirigente">
                  LIMPAR
                </button-cadu>
              </v-col>

              <v-col cols="auto">
                <button-cadu @click="salvarDadosNormal">
                  SALVAR
                </button-cadu>
              </v-col>
            </v-row>
          </v-row>

          <v-row justify="start" v-else>
            <v-col cols="auto">
              <button-cadu outline @click="fecharModal"> VOLTAR </button-cadu>
            </v-col>

            <v-row justify="end">
              <v-col cols="auto">
                <button-cadu
                  class="mx-2"
                  @click="salvarDados(true)"
                  :backColor="$vuetify.theme.themes.light.primary2"
                  block
                >
                  SALVAR E ADICIONAR OUTRO
                </button-cadu>
              </v-col>

              <v-col cols="auto">
                <button-cadu @click="salvarDados(false)">
                  SALVAR
                </button-cadu>
              </v-col>
            </v-row>
          </v-row>
        </div>
      </div>
    </modal-cadu>

    <overlay-loading v-model="loadingOverlay" />

    <modal-cancelar :value="showModalCancelar" @input="fecharModalCancelar" @cancelar-edicao="trocarObjeto" />

    <error-modal :value="showError" @input="fecharModalErro" :errObj="errObj" />

    <SucessoModal :genericMessage="genericMessage" :showSucess="showSucess" @close="fecharModalSucesso" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { isEqual } from 'lodash'
import Estado from '@/services/AreaAcao/Estado'
import Dirigentes from '@/services/Dirigentes/Dirigentes'
import DirigentesMandatos from '@/services/Mandatos/Dirigentes'
import TipoMandatoComCargo from '@/services/Dominios/tipoMandatoComCargo'
import jwtDecode from 'jwt-decode'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    nomeAcao: {
      type: String,
      default: 'VISUALIZAR',
      validator: (el) => ['VISUALIZAR', 'EDITAR', 'ADICIONAR'].includes(el)
    },
    idDirigente: {
      type: [Number, String],
      default: -1
    },
    idCargo: {
      typé: [String, Number],
      default: -1
    },
    value: {
      type: Boolean,
      default: false
    },
    tipoMandato: {
      type: String,
      default: ''
    },
    dataInicio: {
      type: String,
      default: ''
    },
    dataFim: {
      type: String,
      default: ''
    },
    vigencia: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ativo: false,
      atualizaOnline: false,
      showModalCancelar: false,
      tratamento: '',
      nome: '',
      crm: '',
      uf: {
        sigla: '',
        id: ''
      },
      cpf: '',
      sexo: [],
      dataNascimento: '',
      naoMedico: false,
      listaUfs: [],
      tokenBearer: localStorage.getItem('tokenBearer'),
      role: '',
      dirigentes: '',
      dirigentesMandatos: '',
      showError: false,
      errObj: {},
      isLoading: false,
      loadingOverlay: false,
      email: '',
      emails: [
        {
          emailAdress: ''
        }
      ],
      telefoneComercial: '',
      telefoneCelular: '',
      barraPesquisa: '',
      pesquisaNova: [],
      id: '',
      genericMessage: '',
      showSucess: false,
      idMandatoCargo: '',
      novamente: false,
      cloneDirigente: {},
      valueData: this.value,
      tipoCargo: { nome: '', id: '' },
      listaCargos: []
    }
  },
  beforeMount() {
    this.role = jwtDecode(this.tokenBearer).role
    this.getEstados()
    this.dirigentes = new Dirigentes(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
    this.dirigentesMandatos = new DirigentesMandatos(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
  },
  methods: {
    addMore() {
      this.emails.push({
        emailAdress: ''
      })
    },
    remove(index) {
      this.emails.splice(index, 1)
    },
    async getCargos() {
      const cargoMandato = new TipoMandatoComCargo(this.tokenBearer, this.$appConfig.config.API)

      const res = await this.promiseGeneric(cargoMandato, 'getDominio', this.idCargo)
      this.listaCargos = res.data.cargosMandato
    },
    limparCamposDirigente() {
      this.email = null
      this.telefoneComercial = ''
      this.telefoneCelular = ''
      this.tipoCargo = {}
      this.$refs.telefone.reset()
      this.$refs.celular.reset()
    },
    async fecharModalCancelar() {
      this.showModalCancelar = false;
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden';
      this.$emit('input', false);
    },
    trocarObjeto() {
      this.fecharModalCancelar()
      this.email = this.ajustarEmailDirigente(this.cloneDirigente.email);
      this.telefoneComercial = this.cloneDirigente.telefoneComercial
      this.telefoneCelular = this.cloneDirigente.telefoneCelular
      this.tipoCargo = { ...this.cloneDirigente.cargo }
      this.$refs.telefone.reset()
      this.$refs.celular.reset()
    },
    async fecharModalSucesso() {
      this.showSucess = false

      if (this.novamente) {
        this.valueData = false
        this.limparCampos()
        await this.$nextTick()
        this.valueData = true
        document.documentElement.style.overflow = 'hidden'
        this.novamente = false
        return
      }
      this.$emit('input', false)
      this.$emit('att')
    },
    async preencherTodosCampos(mandato) {
      this.cloneDirigente = {
        email: this.ajustarEmailDirigente(mandato.email),
        telefoneCelular: mandato.telefoneCelular,
        telefoneComercial: mandato.telefoneComercial,
        cargo: { ...mandato.cargo }
      }

      if (!mandato.cargo.ativo && this.nomeAcao === 'VISUALIZAR') this.listaCargos.push(mandato.cargo)

      this.tipoCargo = mandato.cargo
      this.idMandatoCargo = mandato.id
      this.email = this.ajustarEmailDirigente(mandato.email);
      this.telefoneComercial = mandato.telefoneComercial
      this.telefoneCelular = mandato.telefoneCelular
      this.id = mandato.dirigente.id
      this.tratamento = mandato.dirigente.tratamento
      this.cpf = mandato.dirigente.cpf
      this.nome = mandato.dirigente.nome
      this.crm = mandato.dirigente.crm
      this.sexo = [mandato.dirigente.sexo]
      this.naoMedico = !mandato.dirigente.medico
      this.uf = mandato.dirigente.estadoCrm
      this.dataNascimento = mandato.dirigente.dataNascimento
    },
    async preencherCampos(dirigente) {
      await this.$nextTick()
      if (!dirigente) return
      this.ativo = dirigente.ativo
      this.atualizaOnline = dirigente.atualizaOnline
      this.cpf = dirigente.cpf
      this.crm = dirigente.crm
      this.dataNascimento = dirigente.dataNascimento
      this.id = dirigente.id
      this.nome = dirigente.nome
      this.sexo = [dirigente.sexo]
      this.naoMedico = !dirigente.medico
      this.uf = dirigente.estadoCrm
      this.tratamento = dirigente.tratamento
      this.email = dirigente.email
      this.telefoneCelular = dirigente.telefoneCelular
      this.telefoneComercial = dirigente.telefoneComercial
    },
    limparCampos() {
      this.ativo = false
      this.atualizaOnline = false
      this.tipoCargo = { nome: '', id: null }
      this.idMandatoCargo = ''
      this.id = ''
      this.tratamento = ''
      this.nome = ''
      this.crm = ''
      this.uf = {
        sigla: '',
        id: ''
      }
      this.cpf = ''
      this.sexo = []
      this.dataNascimento = ''
      this.naoMedico = false
      this.email = ''
      this.emails = [{ emailAdress: '' }]
      this.telefoneComercial = ''
      this.telefoneCelular = ''
      this.barraPesquisa = ''
      this.pesquisaNova = []
    },
    async fecharModalErro() {
      this.showError = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    indexUf(index) {
      this.uf.id = index > -1 && index !== null ? this.listaUfs[index].id : ''
    },
    cancelarEdicao() {
      const obj = {
        email: this.email,
        telefoneCelular: this.telefoneCelular.replace(/[^0-9.]/g, ''),
        telefoneComercial: this.telefoneComercial.replace(/[^0-9.]/g, ''),
        cargo: this.tipoCargo
      }
      if (!isEqual(this.cloneDirigente, obj)) {
        this.showModalCancelar = true;
      } else {
        this.showModalCancelar = false;
        this.$emit('input', false);
      }
    },
    async pesquisar() {
      if (!this.barraPesquisa) return
      this.isLoading = true
      const res = await this.promiseGeneric(this.dirigentes, 'getPesquisa', this.barraPesquisa)
      if (res.data.length === 0) {
        this.showError = true
        this.errObj.error = 'Médico ou não médico cooperado não localizado!'
      }
      this.pesquisaNova = res.data
      this.isLoading = false
      await this.$nextTick
      this.$refs.barraPesquisa.mostrarMenu = true
    },
    salvarDadosNormal() {
      this.salvarDados(false)
    },
    async salvarDados(boolean) {
      const res = await this.$refs.observer.validate()

      if (!res || this.isLoading) return

      this.novamente = boolean

      let tipoDirigente = this.tipoMandato.includes('CONSELHO') ? 'Conselheiro' : 'Dirigente'

      this.genericMessage =
        this.nomeAcao === 'EDITAR' ? `${tipoDirigente} editado com sucesso` : `${tipoDirigente} criado com sucesso`

      let newEmails = []
      let emailsPopulados = this.emails.map((e) => e.emailAdress)
      emailsPopulados.forEach((e) => {
        if (!newEmails.includes(e)) newEmails.push(e)
      });
      newEmails = newEmails.join(',')

      const obj = {
        cargo: {
          id: this.tipoCargo.id,
          nome: this.tipoCargo.nome
        },
        dirigente: {
          id: this.id,
          cpf: this.cpf.replace(/[^0-9]/g, ''),
          sexo: this.sexo[0],
          tratamento: this.tratamento,
          dataNascimento: this.dataNascimento,
          nome: this.nome,
          crm: this.crm
        },
        email: newEmails,
        id: this.idMandatoCargo || null,
        telefoneCelular: this.telefoneCelular,
        telefoneComercial: this.telefoneComercial
      }

      this.loadingOverlay = true
      await this.promiseGeneric(this.dirigentesMandatos, 'putDirigentes', obj, this.$idUnimed)
      this.loadingOverlay = false
      this.showSucess = true
      document.documentElement.style.overflow = 'hidden'
      localStorage.setItem('dirigentesMudaram', true)
    },
    ajustarEmailDirigente(emailDirigente) {
      if (emailDirigente != null) {
        let emails = emailDirigente.split(',')
        let populateEmails = []
        emails.forEach((email) => {
          populateEmails.push({ emailAdress: email })
        })
        this.emails = populateEmails;
      } else {
        this.emails = [{emailAdress: '' }];
      }  
    },
    setIdCargo(idx) {
      if (idx >= 0) this.tipoCargo.id = this.listaCargos[idx].id
      else this.tipoCargo.id = null
    },
    fecharModal() {
      this.$emit('input', false)
    },
    async salvarNovamente() {
      await this.salvarDados(true)
    },
    async getEstados() {
      const estado = new Estado(this.tokenBearer, this.$appConfig.config.API)
      const res = await this.promiseGeneric(estado, 'getEstados', '')
      this.listaUfs = res.data
    },
    promiseGeneric(className, nomeFunc, ...valoresFunc) {
      return new Promise(async (resolve, reject) => {
        try {
          resolve(await className[nomeFunc](...valoresFunc))
        } catch (err) {
          if (this.valueData) {
            this.isLoading = false
            this.loadingOverlay = false
            this.showError = true
            if (err.response) {
              if (err.response.data.httpStatus == 'UNPROCESSABLE_ENTITY') {
                this.errObj.status = err.response.status
                this.errObj.error = `${err.response.data.message} no mandato ${this.tipoMandato}`
              } else {
                this.errObj.status = err.response.status
                this.errObj.error = err.response.data.message
              }
            }
            reject(err)
          }
        }
      })
    }
  },
  computed: {
    isColaboradorDirigente() {
      return this.role === 'colaborador_dirigente'
    }
  },
  watch: {
    valueData() {
      if (this.novamente) return
      if (!this.valueData) {
        this.limparCampos()
        this.$emit('input', this.valueData)
      }
    },
    value() {
      this.valueData = this.value
    }
  }
}
</script>

<style lang="sass">
.cargo-dirigente > .IZ-select__menu
  position: absolute !important
</style>
